





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import dialogComp from '@/components/dialog/index.vue';
import { Button } from 'mint-ui';
import qs from 'qs';
import { commonShare } from '@/utils/hybird';

@Component<VBANNER>({
  components: {
    dialogComp,
    'mt-button': Button,
  },
})
export default class VBANNER extends Vue {
  public tipType: number = 0; /* 0是已参与过活动，1是未中奖 */
  public tipError: string = '';
  public voteList: any = [];
  public showResult: boolean = false;
  public setting: any = {
    dl: 0,
    fx: 0,
    xcx1: 0,
    xcx2: 0,
    zs: 0,
  };
  public linkList: any = [
    'https://m.picc.com/wproduct/#/entryroute?productCode=EAK_0017',
    'https://mlife.picc.com/ebsweb/#/newfs_fusion?combCode=C71940&utmSource=234&utmType=1&platform=f&dataSource=SEM-WAP&JobNo=6111100001&eventsName=wap',
    'https://szgezhangtest.picchealth.com/mall/#/lifeSerious?source=2',
  ];
  public show() {
    (this.$refs.dialog as any).show();
    let timer = setTimeout(() => {
      clearTimeout(timer);
      this.showResult = true;
    }, 500);
  }
  public close() {
    this.showResult = false;
    (this.$refs.dialog as any).close();
  }
  public addTime(source: string) {
    if (source == 'fx') {
      commonShare(() => {
        this.callback &&
          this.callback(source, (setting: any) => {
            this.setting = setting;
          });
      });
      return;
    }
    this.callback &&
      this.callback(source, (setting: any) => {
        this.setting = setting;
        if (source == 'xcx2') {
          window.location.href = this.linkList[Math.floor(Math.random()*3)];
        } else {
          this.close();
        }
      });
  }
  public getChannelNum: any = () => {};
  public getMaxW(item: any) {
    let total = 0;
    this.voteList.forEach((vote: any) => {
      total += vote.num;
    });
    return (item.num / total) * 100;
  }
  public goUrl() {
    location.href =
      'https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong';
  }
  public callback(source?: string, callback?: any) {}
}
